let lastScrollTop = 0;
const scrollThreshold = 120;
let isScrollTicking = false;

function handleSmartStickyHeader() {
  const header = document.querySelector('.sensen-header-container');
  if (!header) return;

  const stickyType = header.getAttribute('data-sticky-type');
  if (stickyType === 'none') return;

  const isPredictiveOpen = header.classList.contains('is-search-open') || 
                           !!document.querySelector('sensen-predictive-search[open]');
  const isMobileSearchOpen = document.getElementById('SensenMobileSearch')?.classList.contains('is-open');
  const isMobileMenuOpen = document.getElementById('SensenMobileCategories')?.classList.contains('is-open');

  if (isPredictiveOpen || isMobileSearchOpen || isMobileMenuOpen) {
    header.classList.remove('is-hidden');
    return;
  }

  const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

  if (stickyType === 'always') {
    if (currentScroll > 10) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
    return;
  }

  if (currentScroll > scrollThreshold) {
    header.classList.add('is-sticky');

    if (currentScroll > lastScrollTop) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }
  } else {
    header.classList.remove('is-sticky', 'is-hidden');
  }

  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
}

window.addEventListener('scroll', () => {
  if (!isScrollTicking) {
    window.requestAnimationFrame(() => {
      handleSmartStickyHeader();
      isScrollTicking = false;
    });
    isScrollTicking = true;
  }
}, { passive: true });

function toggleSensenMobileMenu() {
  const panel = document.getElementById('SensenMobileCategories');
  const button = document.querySelector('.sensen-header__hamburger');
  const searchDropdown = document.getElementById('SensenMobileSearch');
  const searchBtn = document.querySelector('.sensen-header__search-trigger-mobile');
  if (!panel) return;

  if (searchDropdown && searchDropdown.classList.contains('is-open')) {
    searchDropdown.classList.remove('is-open');
    if (searchBtn) searchBtn.classList.remove('is-active');
  }

  const isOpen = panel.classList.contains('is-open');
  if (isOpen) {
    panel.classList.remove('is-open');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      button.classList.remove('is-active');
    }
  } else {
    panel.classList.add('is-open');
    if (button) {
      button.setAttribute('aria-expanded', 'true');
      button.classList.add('is-active');
    }
  }
}

function sensenToggleCatSection(btn) {
  const section = btn.closest('.sensen-mobile-cat-section');
  if (!section) return;
  const subgroups = section.querySelector('.sensen-cat-collapsible');
  if (!subgroups) return;

  const isOpen = subgroups.classList.contains('is-open');
  if (isOpen) {
    subgroups.classList.remove('is-open');
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  } else {
    subgroups.classList.add('is-open');
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
  }
}

function toggleMobileSearch() {
  const searchDropdown = document.getElementById('SensenMobileSearch');
  const triggerBtn = document.querySelector('.sensen-header__search-trigger-mobile');
  const categoriesPanel = document.getElementById('SensenMobileCategories');
  const hamburgerBtn = document.querySelector('.sensen-header__hamburger');
  if (!searchDropdown) return;

  if (categoriesPanel && categoriesPanel.classList.contains('is-open')) {
    categoriesPanel.classList.remove('is-open');
    if (hamburgerBtn) {
      hamburgerBtn.setAttribute('aria-expanded', 'false');
      hamburgerBtn.classList.remove('is-active');
    }
  }

  searchDropdown.classList.toggle('is-open');
  if (triggerBtn) {
    triggerBtn.classList.toggle('is-active', searchDropdown.classList.contains('is-open'));
  }
  if (searchDropdown.classList.contains('is-open')) {
    const input = searchDropdown.querySelector('.sensen-search-input');
    if (input) input.focus();
  }
}

function closeAllSensenHeaderOverlays() {
  const predictiveSearches = document.querySelectorAll('sensen-predictive-search');
  predictiveSearches.forEach((ps) => {
    if (typeof ps.close === 'function') ps.close();
  });

  const categoriesPanel = document.getElementById('SensenMobileCategories');
  if (categoriesPanel && categoriesPanel.classList.contains('is-open')) {
    toggleSensenMobileMenu();
  }

  const searchDropdown = document.getElementById('SensenMobileSearch');
  if (searchDropdown && searchDropdown.classList.contains('is-open')) {
    toggleMobileSearch();
  }
}

const sensenDropdownLayout = {
  columnWidth: 220,
  columnGap: 36,
  groupGap: 28,
  panelPadding: 56,
  maxColumns: 4,
  maxWidth: 1100,
  targetHeight: 300
};

function getSensenDropdownGroups(inner) {
  return Array.from(inner.children).flatMap((child) => {
    if (child.classList.contains('sensen-header__dropdown-layout-column')) {
      return Array.from(child.children);
    }

    return child.classList.contains('sensen-header__dropdown-column') ? [child] : [];
  });
}

function splitSensenDropdown(heights, columnCount) {
  const ranges = [];
  let start = 0;
  let remainingHeight = heights.reduce((sum, height) => sum + height, 0)
    + sensenDropdownLayout.groupGap * Math.max(0, heights.length - columnCount);

  for (let columnIndex = 0; columnIndex < columnCount; columnIndex += 1) {
    const remainingColumns = columnCount - columnIndex;
    const targetHeight = remainingHeight / remainingColumns;
    const lastPossibleEnd = heights.length - (remainingColumns - 1);
    let end = start;
    let columnHeight = 0;

    while (end < lastPossibleEnd) {
      const nextHeight = heights[end] + (end > start ? sensenDropdownLayout.groupGap : 0);
      if (end > start && columnHeight + nextHeight > targetHeight) {
        const currentDifference = Math.abs(targetHeight - columnHeight);
        const nextDifference = Math.abs(targetHeight - columnHeight - nextHeight);
        if (nextDifference < currentDifference) {
          columnHeight += nextHeight;
          end += 1;
        }
        break;
      }

      columnHeight += nextHeight;
      end += 1;
    }

    ranges.push([start, end]);
    remainingHeight -= columnHeight;
    start = end;
  }

  return ranges;
}

function layoutSensenDropdown(panel) {
  const inner = panel.querySelector('.sensen-header__dropdown-inner');
  const groups = inner ? getSensenDropdownGroups(inner) : [];
  if (!inner || groups.length === 0) return;

  inner.replaceChildren(...groups);
  inner.classList.add('is-measuring');
  const heights = groups.map((group) => Math.ceil(group.getBoundingClientRect().height));
  inner.classList.remove('is-measuring');

  const availableWidth = Math.min(sensenDropdownLayout.maxWidth, window.innerWidth - 40);
  const availableColumns = Math.floor(
    (availableWidth - sensenDropdownLayout.panelPadding + sensenDropdownLayout.columnGap)
    / (sensenDropdownLayout.columnWidth + sensenDropdownLayout.columnGap)
  );
  const maxColumns = Math.max(1, Math.min(
    sensenDropdownLayout.maxColumns,
    groups.length,
    availableColumns
  ));
  const header = document.querySelector('.sensen-header-container');
  const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
  const availableHeight = Math.max(240, window.innerHeight - headerBottom - 32);
  const totalHeight = heights.reduce((sum, height) => sum + height, 0)
    + sensenDropdownLayout.groupGap * Math.max(0, groups.length - 1)
    + sensenDropdownLayout.panelPadding;
  const targetHeight = Math.min(sensenDropdownLayout.targetHeight, availableHeight);
  const columns = Math.min(maxColumns, Math.max(1, Math.ceil(totalHeight / targetHeight)));
  const ranges = splitSensenDropdown(heights, columns);

  const layoutColumns = ranges.map(([start, end]) => {
    const column = document.createElement('div');
    column.className = 'sensen-header__dropdown-layout-column';
    column.append(...groups.slice(start, end));
    return column;
  });

  panel.style.setProperty('--sensen-dropdown-columns', columns);
  inner.replaceChildren(...layoutColumns);
  const width = Math.ceil(panel.getBoundingClientRect().width);

  const menuItem = panel.closest('.sensen-header__menu-item');
  if (menuItem) {
    const itemRect = menuItem.getBoundingClientRect();
    const desiredLeft = itemRect.left + itemRect.width / 2 - width / 2;
    const viewportLeft = 20;
    const viewportRight = window.innerWidth - 20;
    const clampedLeft = Math.min(
      Math.max(desiredLeft, viewportLeft),
      viewportRight - width
    );
    panel.style.setProperty('--sensen-dropdown-left', `${clampedLeft - itemRect.left}px`);
  }
}

function initSensenDesktopDropdowns(root = document) {
  const panels = root.querySelectorAll('[data-sensen-dropdown]');
  panels.forEach(layoutSensenDropdown);

  root.querySelectorAll('.sensen-header__menu-item.has-dropdown').forEach((item) => {
    if (item.dataset.sensenDropdownReady === 'true') return;

    const trigger = item.querySelector('.sensen-header__menu-link[aria-haspopup="true"]');
    if (!trigger) return;

    const setExpanded = (expanded) => {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    item.dataset.sensenDropdownReady = 'true';
    item.addEventListener('pointerenter', () => setExpanded(true));
    item.addEventListener('pointerleave', () => {
      if (!item.contains(document.activeElement)) setExpanded(false);
    });
    item.addEventListener('focusin', () => setExpanded(true));
    item.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!item.contains(document.activeElement)) setExpanded(false);
      }, 0);
    });
    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      setExpanded(false);
      trigger.focus();
    });
  });
}

let sensenDropdownResizeFrame;
window.addEventListener('resize', () => {
  window.cancelAnimationFrame(sensenDropdownResizeFrame);
  sensenDropdownResizeFrame = window.requestAnimationFrame(() => initSensenDesktopDropdowns());
}, { passive: true });

document.addEventListener('shopify:section:load', (event) => {
  initSensenDesktopDropdowns(event.target);
});

initSensenDesktopDropdowns();

document.addEventListener('click', (event) => {
  const categoriesPanel = document.getElementById('SensenMobileCategories');
  const searchDropdown = document.getElementById('SensenMobileSearch');
  const headerContainer = document.querySelector('.sensen-header-container');

  if (!headerContainer) return;

  if (categoriesPanel && categoriesPanel.classList.contains('is-open')) {
    if (!headerContainer.contains(event.target)) {
      toggleSensenMobileMenu();
    }
  }

  if (searchDropdown && searchDropdown.classList.contains('is-open')) {
    if (!headerContainer.contains(event.target)) {
      toggleMobileSearch();
    }
  }
});

(function initHeaderSpacer() {
  const container = document.querySelector('.sensen-header-container');
  if (!container) return;

  function syncHeight() {
    document.documentElement.style.setProperty(
      '--sensen-header-h',
      container.offsetHeight + 'px'
    );
  }

  syncHeight();

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(syncHeight).observe(container);
  }
})();

(function initSearchWildcard() {
  var form = document.getElementById('sensen-header-search-form');
  if (!form) return;
  var visibleInput = form.querySelector('input[name="q"]');
  if (!visibleInput) return;

  if (document.title.indexOf('*') > -1) document.title = document.title.replace(/\*/g, '');

  var hiddenInput = document.createElement('input');
  hiddenInput.type = 'hidden';
  hiddenInput.name = 'q';
  form.appendChild(hiddenInput);

  form.addEventListener('submit', function () {
    var query = visibleInput.value.trim();
    hiddenInput.value = query.length ? (query.endsWith('*') ? query : query + '*') : '';
    visibleInput.removeAttribute('name');
  });
})();
